import { defineComponent, ref } from "vue";
import previewModal from "@/components/PreviewModal/index.vue";
export default defineComponent({
    props: {
        btnText: {
            type: String,
            default: "\u9884\u89C8"
        },
        title: {
            type: String,
            default: ""
        },
        html_url: {
            type: String,
            default: ""
        }
    },
    components: {
        previewModal: previewModal
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var previewDialog = ref({
            visible: false,
            title: "",
            html_url: "",
            cn_html_url: "",
            showCnUrl: false,
            id: ""
        });
        var handleClick = function() {
            previewDialog.value.visible = true;
            previewDialog.value.title = props.title;
            previewDialog.value.html_url = props.html_url;
        };
        var handleClose = function() {
            previewDialog.value.visible = false;
        };
        return {
            previewDialog: previewDialog,
            handleClick: handleClick,
            handleClose: handleClose
        };
    }
});
